import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import RoutesObjects from "./routes";
import { useAuth } from "./context/authContext";
function App() {
  const [fetchingUser, setFetchingUser] = useState(true);
  const auth = useAuth();
  useEffect(() => {
    const { initUser, user, setUser, logout } = auth;
    const userObj = JSON.parse(localStorage.getItem("user"));
    if (userObj) {
      let expiryDate = new Date(userObj.auth?.expiryDate);
      let todaysDate = new Date();
      if (!user) {
        setUser(userObj);
      }

      if (todaysDate > expiryDate) {
        logout();
      }
    } else {
    }
    setFetchingUser(false);
  }, [auth.user]);
  return (
    <div className="w-full overflow-x-hidden font-DMSans  ">
     
        <Router>
          <Routes>
            {RoutesObjects.map((route) => (
              <Route path={route.path} element={route.element} key={route.id} />
            ))}
          </Routes>
        </Router>


      {/* <Dashboard>
        <Faqs />
      </Dashboard> */}
    </div>
  );
}
// end

export default App;
